/**
 * donation-form — pure input formatters. SYNC: see ../_SYNC.md (byte-identical
 * across opublic-front + oportal). Imports nothing from the host.
 */
/** Strip everything but digits, optionally capping the length. */
export function sanitizeDigits(value, max) {
    const digits = (value || "").replace(/[^0-9]/g, "");
    return typeof max === "number" ? digits.slice(0, max) : digits;
}
